export default ngModule => {
  ngModule.controller('ComparatorStep3CtrlAUF', function ($scope, AonConfig) {
    const ctrl = $scope.$parent.ctrl;
    const isOperator = ctrl.corporate.is_operator;

    if (isOperator) {
      const disclaimer = _.get(ctrl.fieldsets, 'config.operator_disclaimer', null);
      if (disclaimer) {
        this.disclaimer = disclaimer;
        this.disclaimerPosition = 'bottom';
      }
    } else {
      const disclaimer = _.get(ctrl.fieldsets, 'config.online_disclaimer', null);
      if (disclaimer) {
        this.disclaimer = disclaimer;
        this.disclaimerPosition = 'top';
      }
    }

    this.resetPaymentDateRange = () => {
      const aufMinDate = new Date(Math.max(new Date(), $scope.ctrl.application.payment.join_date));
      this.minDate = aufMinDate > ctrl.join_date_minimum ? aufMinDate : ctrl.join_date_minimum;
      this.maxDate = new Date(this.minDate);
      this.maxDate.setMonth(this.minDate.getMonth() + 1);
      this.payment = $scope.$parent.ctrl.application.payment;
      this.payment.debit_date = this.minDate;
    };
    this.resetPaymentDateRange();

    $scope.$watch('ctrl.application.payment.join_date', () => {
      this.resetPaymentDateRange();
    });

    // If any of the dependants on the application are DEPENDANT_STUDENT's, we need to show
    // some scripting in the form.
    this.showDependantStudentScripting = () => {
      const studentCode = AonConfig.jsConstants.RelationshipsLookup.DEPENDANT_STUDENT;
      const dependantStudents = _.get(ctrl.application, 'dependants', []).filter(
        dependant => _.get(dependant, 'relationship', null) === studentCode);
      return dependantStudents.length > 0;
    };

  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-auf.js